import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";

let _ScrollDebouncerOptions = {
  viewport: window.document.documentElement
};

class _ScrollDebouncer extends Class {
  constructor(options) {
    super();
    this.setOptions(_ScrollDebouncerOptions, options);
    this.animFrameStarted = false;
    this.startScroll();
  }

  startScroll() {
    var self = this;
    $(window).on("scroll", function() {
      self.onScroll();
    });
    this.onScroll();
  }

  onScroll() {
    this.scrollHandler();
  }

  scrollHandler() {
    var self = this;
    if (!this.animFrameStarted) {
      this.animFrameStarted = true;
      requestAnimationFrame(function() {
        self.update();
      });
    }
  }

  update() {
    $(this).trigger("scroll");
    this.animFrameStarted = false;
  }
}

let ScrollDebouncer = new _ScrollDebouncer();

export { ScrollDebouncer };



// WEBPACK FOOTER //
// ./Javascript/core/classes/scroll/scroll.debouncer.class.js